import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import {
  changeBoxRegistrar,
  SetSelectedBoxes,
  showUpdateEpikBox,
  getEpikBoxData,
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT } from '../../../../../lib/constants';
import InfoPopup from '../../../../InfoPopup';
import Toggle from '../../../../Toggle';
import addNote from '../../../../../lib/api/addNote';

const boxRegistrarLookup = {
  Unified: false,
  midRegistrar: true,
}

const BoxRegistrar = ({registrationOffSet}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken');
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);

  const [boxregistrar, setBoxRegistrar] = useState(
    boxRegistrarLookup[boxDetails.boxRegistrar] || false,
  );
  const checkSecurityCode = async () => {
    const result = await dispatch(changeBoxRegistrar(token, boxDetails._id, !boxregistrar));
    if (result) {
      await dispatch(getEpikBoxData(token, boxDetails?._id));
      setBoxRegistrar(!boxregistrar);
      const note = `Registration Offset changed from ${boxregistrar ? 'enabled' : 'disabled'} to ${
        boxregistrar ? 'disabled' : 'enabled'
      }`;
      addNote({ boxID: boxDetails?._id, note });
    }
  };

  const onBoxRegistrar = () => {
    checkSecurityCode();  // Directly call the function without modal
  };

  return (
    <Row className="align-items-center">
      <Col sm={5} id="test-enable-expansion-box" className="type-header d-flex">
        Enable Registration Offset
        <sup>
          <InfoPopup id="enable-new-box-registrar" text={TOOLTIPS_TEXT.BOX_REGISTRAR_CHANGE} />
        </sup>
      </Col>

      <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
        <Toggle
          value={boxregistrar}
          id="test-enable-expansion-box-toggle"
          onToggle={
            (registrationOffSet === 'write' || registrationOffSet === 'both')
                      ? onBoxRegistrar
                      : undefined
          }
          disabled={ registrationOffSet === 'read' || !['la'].includes(boxDetails?.datacenter)}
        />
      </Col>
    </Row>
  );
};

export default BoxRegistrar;
